import React from 'react';
import { Box } from 'rebass';
import { Controller, Scene } from 'react-scrollmagic';

import ContentContainer from '../../components/ContentContainer/ContentContainer';
import Typography, {
  TypographyContextProvider,
} from '../../components/Typography/Typography';

import colourMatching from '../../utils/colourMatching';
import isFadeEnabled from '../../utils/isFadeEnabled';
import { BlockquoteSectionStoryblok } from '../../types/storyblok';

/**
 * Blockquote content
 * @param {Object} props
 * @param {string} [props.colourScheme]
 * @param {string} props.text
 */
const BlockquoteSection = ({
  colourScheme,
  text,
}: BlockquoteSectionStoryblok) => (
  <TypographyContextProvider value={{ colourScheme }}>
    <Box as="section" py={8} backgroundColor={colourMatching(colourScheme)}>
      <Controller globalSceneOptions={{ triggerHook: 'onEnter' }}>
        <Scene classToggle="full-opacity">
          <Box className={isFadeEnabled() ? 'zero-opacity' : ''}>
            <ContentContainer>
              <Typography
                component="blockquote"
                textAlign="center"
                variant="h2"
              >
                {text}
              </Typography>
            </ContentContainer>
          </Box>
        </Scene>
      </Controller>
    </Box>
  </TypographyContextProvider>
);

export default BlockquoteSection;
